// extracted by mini-css-extract-plugin
export var pillTrigger = "_60-0";